/**
 * ErpDocumentsTab — zakładka „Dokumenty z Symfonii” ekranu Integracja ERP (FK).
 *
 * Dokumenty księgowe idą TYLKO w eksporcie (my → FK) — zero pobierania z FK (decyzja stała).
 * Dlatego zakładka służy WYŁĄCZNIE konfiguracji wysyłki: mapowanie typów (nasz typ → typ FK) +
 * mapowanie pól per typ (rozwijane pod każdym typem). Dawne lustro „zaimportowanych dokumentów”
 * (GET /erp-documents) było zaszłością funkcji importu (Handel → potem dry-run FK) i zostało
 * usunięte — nie pasuje do modelu tylko-eksport.
 */

import { useTranslation } from 'react-i18next';

import { DocumentTypeMappingsSection } from './DocumentTypeMappingsSection';

export function ErpDocumentsTab({
  integrationId,
  erpSystem,
  connectionMode,
}: { integrationId?: string; erpSystem?: string; connectionMode?: string } = {}) {
  const { t } = useTranslation();

  if (!integrationId) {
    return (
      <p className="rounded-lg border border-dashed border-border-secondary p-4 text-sm text-text-secondary">
        {t('tenant.settings.integrations.docTypeMappings.noTypes')}
      </p>
    );
  }

  return (
    <DocumentTypeMappingsSection
      integrationId={integrationId}
      erpSystem={erpSystem}
      connectionMode={connectionMode}
    />
  );
}
